module.exports = __webpack_public_path__ + "media/images/riders/small/ANTON_COOPER-0035287776b8c3bbe8fe52cad4517a11.png";